"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PearsonAccordion = exports.AccordionItem = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PearsonAccordion = exports.PearsonAccordion = function PearsonAccordion(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  // Convert children to HTML string
  var itemsHtml = _react["default"].Children.map(children, function (child) {
    if ( /*#__PURE__*/_react["default"].isValidElement(child)) {
      var _child$props = child.props,
        label = _child$props.label,
        childContent = _child$props.children;
      return "<div label=\"".concat(label, "\">").concat(childContent, "</div>");
    }
    return null;
  }).join('');
  var htmlString = "\n        <pearson-accordion theme=\"".concat(theme, "\">\n            ").concat(itemsHtml, "\n        </pearson-accordion>\n    ");
  return /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: htmlString
    }
  });
};
var AccordionItem = exports.AccordionItem = function AccordionItem(_ref2) {
  var label = _ref2.label,
    children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    label: label
  }, children);
};
var _default = exports["default"] = PearsonAccordion;